import React, { useEffect, useRef, isValidElement } from 'react'
import styled from 'styled-components'

const MenuTitleElement = styled.div`
  font-size: 0.7rem;
  padding: 0.5rem 1rem;
  font-weight: bold;
  cursor: default;
`

const MenuWrapperElement = styled.ul`
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  padding: 5px 0;
  background-color: white;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  z-index: 1;
  list-style: none;
`

const MenuItemWrapperElement = styled.li``

function Menu({ onClose, children, title }) {
  const menuRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      !menuRef.current.contains(event.target) && onClose()
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [onClose])

  return (
    <MenuWrapperElement innerRef={menuRef}>
      {title && <MenuTitleElement>{title}</MenuTitleElement>}
      {React.Children.map(children, (child) =>
        isValidElement(child) ? (
          <MenuItemWrapperElement onClick={onClose}>
            {child}
          </MenuItemWrapperElement>
        ) : null
      )}
    </MenuWrapperElement>
  )
}

export default Menu
